// Barrel: a tube along the axis, optionally with a top rib or can fins.
import { detailStroke, type Part, part } from '../../passes.ts';
import { box, line, poly } from '../../shapes.ts';
import { type GunKit, lrect } from './types.ts';

export function barrel(g: GunKit): Part[] {
  const { kind, x, len, th } = g.r.barrel;
  const sw = g.pal.sw(g.r.second);
  const out: Part[] = [];
  if (kind === 'fins') {
    const acc = g.pal.sw(g.r.accent);
    for (const fx of [x + len * 0.2, x + len * 0.55]) {
      for (const s of [-1, 1]) {
        const pts: [number, number][] = [
          [fx, (s * th) / 2],
          [fx + 12, (s * th) / 2],
          [fx + 4, s * (th / 2 + 8)],
        ];
        out.push(part(poly(pts), acc, box(fx, Math.min(0, s * (th / 2 + 8)), 12, th / 2 + 8)));
      }
    }
  }
  out.push(
    lrect(g, g.r.second, x - 2, -th / 2, len + 2, th, th * 0.3, {
      detail: (c) => {
        if (kind === 'rib') {
          detailStroke(
            c,
            line([
              [x + 3, -th / 2 + 2.5],
              [x + len - 3, -th / 2 + 2.5],
            ]),
            sw.light,
            g.ow,
          );
        }
        if (kind === 'fat') {
          for (const fx of [x + len * 0.3, x + len * 0.6]) {
            detailStroke(
              c,
              line([
                [fx, -th / 2 + 2],
                [fx, th / 2 - 2],
              ]),
              sw.shade,
              g.ow,
            );
          }
        }
      },
    }),
  );
  return out;
}
